module.exports = __webpack_public_path__ + "assets/images/JMDUNFIT50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDUNFIT50.png
// module id = 1405
// module chunks = 1